
document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);
    const components = document.querySelectorAll(".accordion-culture-insights-v3");
    components.forEach((component) => {
        const container = component.querySelector(".accordion-culture-insights-v3 .tab-section");
        const tabs = container.querySelectorAll(".accordion-culture-insights-v3 .tab-section .tab-card");
        const images = container.querySelectorAll(".accordion-culture-insights-v3 .tab-section .tab-image");

        if (!container || tabs.length === 0 || images.length === 0) return;

        // Calculate scroll height based on tab height
        const tabHeight = tabs[0].offsetHeight;
        const totalScrollHeight = tabHeight * tabs.length;

        // Pin the tab section for this component
        ScrollTrigger.create({
            trigger: container,
            start: "top-=50 top", // ⬅️ Start pinning 100px below top
            end: "+=" + totalScrollHeight,
            pin: true,
            scrub: 2
        });

        // Activate each tab when it reaches the top
        tabs.forEach((tab, index) => {
            ScrollTrigger.create({
                trigger: tab,
                start: "top top",
                end: "bottom top",
                onEnter: () => activateTab(index),
                onEnterBack: () => activateTab(index)
            });
        });

        function activateTab(index) {
            tabs.forEach((tab, i) => {
                tab.classList.toggle("active", i === index);
                images[i].classList.toggle("active", i === index);
            });
        }

        // Optional: click and keyboard support
        tabs.forEach((tab, index) => {
            tab.addEventListener("click", () => activateTab(index));
            tab.querySelector(".tab-header").addEventListener("keypress", e => {
                if (e.key === "Enter") activateTab(index);
            });
        });
    });
});